import React from 'react';
import styled from '@emotion/styled';

const MessageWrapper = styled.div`
  & div[data-testid='green-message'] {
    background-color: #d1fadf;
    border-radius: 0 0 0 var(--Unit-32, 32px);
  }
`;
export const GreenMessage = props => {
  const { children } = props;
  return <MessageWrapper>{children}</MessageWrapper>;
};
